import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import BaseLayout from './../../templates/base'
import {confirmAlert} from "react-confirm-alert";
import InmPagination from "../../elements/widgets/inmPagination";
import Loading from './../../elements/loading';
import _ from 'lodash';
import VersionsAdd from './../../elements/versions/widget/versions_add';

class Versions extends Component {
	render() {
		let { versions } = this.props;
		let vu = _.find(versions.permissions, (o) => {return o==='Update'});
		let vd = _.find(versions.permissions, (o) => {return o==='Delete'});
		return (
			<div>
				{versions.isFetching ? <Loading /> :
					<table className={`inm-table`}>
						<thead>
						<tr>
							<th>ID</th>
							<th>Título</th>
							<th>Año</th>
							<th>Inicia</th>
							<th>Termina</th>
							<th>Estatus</th>
						</tr>
						</thead>
						<tbody>
						{_.map(versions.list, (row, k) => {
							return (
								<tr key={k}>
									<td style={{width:'80px'}}>
										<div className="actions">
											{vu ? <NavLink to={`/versiones/editar/${row.year}`}><i className="fa fa-edit"></i></NavLink>:''}
											{vd ? <button onClick={() => this._getConfirm(row.year,row.name)}><i className="fa fa-trash-o"></i></button>:''}
										</div>
										{row.id}
									</td>
									<td>{row.name}</td>
									<td>{row.year}</td>
									<td>{row.start_date}</td>
									<td>{row.end_date}</td>
									<td>
										<strong className={`has-text-${row.finished ? 'danger':'success'}`}>
											{row.finished ? 'Finalizado':'Activo'}
										</strong>
									</td>
								</tr>
							)
						})}
						</tbody>
					</table>}
				{versions.pages.total>20 &&
				<InmPagination key="concepts-pages"
				               current={versions.pages.current}
				               total={versions.pages.total}
				               nextPage={this._handlePageChange}/>}
			</div>
		)
	}

	constructor() {
		super();
		this._handlePageChange = this._handlePageChange.bind(this);
	}

	componentWillMount(){
		this.props.fetchVersionsShow();
	}

	_handlePageChange(value) {
		this.props.fetchVersionsShow(value);
	}

	_getConfirm(year, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar la version "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.versionDelete(year)
		})
	}
}

export default BaseLayout(Versions, {
	title:`Administrar Versiones`,
	subnav: {
		icon: 'fa fa-calendar-check-o',
		name: 'Versiones',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <VersionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/versions/index.jsx